/**
 * One categorical palette for every chart (docs/DASHBOARD_SPECIFICATION.md §1.1): at most eight
 * colours, chosen to stay apart for the common kinds of colour blindness, and dark enough to keep
 * 3:1 against the white card (test/contrast.test.ts). Colour never carries meaning alone: every
 * series also has a label, a legend or a table.
 */
export const CHART_COLORS = [
  '#0072b2', // blue
  '#c04f00', // vermilion
  '#00855f', // bluish green
  '#a8487f', // reddish purple
  '#a86a00', // orange
  '#374151', // slate
  '#8a7f00', // olive
] as const;

/** The same colours re-tuned for the dark card (index.css `.dark`), in the same order. */
export const CHART_COLORS_DARK = [
  '#56b4e9',
  '#f0884b',
  '#2ec4a0',
  '#e07bb8',
  '#e6a23c',
  '#cbd5e1',
  '#d4c94a',
] as const;

/** Leads without a source, "other" and unknown groups. */
export const NEUTRAL_COLOR = '#6b7280';
export const NEUTRAL_COLOR_DARK = '#9ca3af';

/** What components paint with: CSS variables, so a theme switch recolours every chart. */
export const NEUTRAL_FILL = 'var(--chart-neutral)';
const chartVar = (index: number): string => `var(--chart-${index + 1})`;

function hash(text: string): number {
  let value = 0;
  for (const char of text) value = (value * 31 + char.codePointAt(0)!) >>> 0;
  return value;
}

/** The same key (a salesperson, a source) keeps the same colour in every chart. */
export function colorFor(key: string | null): string {
  if (key === null) return NEUTRAL_FILL;
  return chartVar(hash(key) % CHART_COLORS.length);
}
